<template lang="html">
  <div class="irrigation">

    <div class="top-heading">
      <h2 v-if="$store.getters['program/data'].type == 'soil-based'">
        <!-- TODO добавить переводы и в srcipt -->
        {{ $ml.get(`Irrigation`) }}
      </h2>
      <app-btn
        :disabled="!program.waterTestId"
        @click="saveIrrigation()"
        :loading="loading.save"
      >
        {{ $ml.get(`save`) }}
      </app-btn>
    </div>

    <app-loading :loading="loading.sync" class="table">
      <div class="a-row heading">
        <div class="first">{{$ml.get(`STAGE NAME`)}}</div>
        <div class="second">{{$ml.get(`TOTAL WATER PER STAGE, `)}} {{$store.getters['unit/getLabel']('m3')}}</div>
        <div class="third">{{$ml.get(`STAGE DURATION, days`)}}</div>
      </div>

      <div class="a-row total" :class="{ disable: irrigation.type != 'general'}">
        <div class="toggle" @click="irrigation.type = 'general'">
          <i v-if="irrigation.type != 'general'" class="material-icons" >check_box_outline_blank</i>
          <i v-else class="material-icons" style="color:$mainGreen">check_box</i>
        </div>
        <div class="first">{{ $ml.get(`Total`) }}</div>
        <div class="second">
          <input
            :min="0"
            :disabled="irrigation.type != 'general'"
            :label="irrigation.data.general.water"
            type="number"
            v-model="irrigation.data.general.water"
            @keypress="checkNum"
            step="any"
          />
        </div>
        <div class="third">{{ irrigation.data.general.duration }}</div>
      </div>

      <div class="by-stages">

        <div v-for="(stage, key, i) in irrigation.data.perStage"
          class="a-row stage"
          :class="{ disable: irrigation.type != 'per-stage'}"
        >

          <div class="toggle" v-if="i == 0" @click="irrigation.type = 'per-stage'">
            <i v-if="irrigation.type != 'per-stage'" class="material-icons" >check_box_outline_blank</i>
            <i v-else class="material-icons" style="color:$mainGreen">check_box</i>
          </div>

          <div class="first">{{ stage.name }}</div>
          <div class="second">
            <input
              :min="0"
              :disabled="irrigation.type != 'per-stage'"
              :label="stage.water"
              type="number"
              step="any"
              v-model="stage.water"
              @keypress="checkNum"
            />
          </div>
          <div class="third">{{ stage.duration }}</div>
        </div>
      </div>
    </app-loading>
  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      data: {},
      loading: {
        sync: false,
        save: false,
      }
    }
  },
  methods : {
    checkNum(e) {
      let charCode = String.fromCharCode(e.keyCode)
      if(!(/[0-9.,]/).test(charCode)) {
        e.preventDefault();
      }
    },
    saveIrrigation() {
      if(!this.program.waterTestId) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get('You must select water test first!'),
          type : 'error',
        });
      } else {
        this.loading.save = true;
        this.$store.dispatch('program/tests/saveIrrigation').then(res => {
          console.log(res)
          this.$notify({
            group: 'notices',
            title: this.$ml.get('Irrigation was successfully updated!'),
            type : 'success',
          });
        }).finally(() => {
          this.loading.save = false;
        });
      }
    },
  },
  created() {
    this.loading.sync = true;
    this.$store.dispatch('program/tests/getIrrigation').then(res => {
      console.log(res)
      
      for(let i in this.irrigation.data.perStage) {
        console.log(this.irrigation.data.perStage[i].water)
        // this.irrigation.data.perStage[i].water = this.$store.getters['unit/unConvert']('m3', this.irrigation.data.perStage[i].water).toFixed(2)
      }
    })
      .finally(() => {
        this.loading.sync = false;
      });
  },
  beforeDestroy () {
    // this.saveIrrigation();
  },
  computed : {
    ...mapGetters({
      program: 'program/data',
      irrigation: 'program/tests/irrigation',
    }),
  },
}
</script>

<style lang="scss" scoped>
.irrigation {
  margin-top: 48px;
  .table {
    margin-top: 30px;
  }
  input {
    border-width: 0;
    padding-left: 0;
    width: 100px;
    -moz-appearance: textfield;
    color: $mainGreen;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin: 0;
      -webkit-appearance: none;
    }
    &:disabled {
      background: transparent;
      opacity: .3;
    }
    
  }
    > span {
      display: none;
        }
  .a-row {
    position: relative;
    .toggle {
      position: absolute;
      left: 1px;
      cursor: pointer;
      i {
        font-size: 16px;
        color: #4C5056;
      }
    }
    &.disable {
      color: #E4E5E6;

      .text-input::v-deep label input {
        color: #E4E5E6;
        pointer-events: none;
        &::placeholder {
          color: #E4E5E6;
        }
      }
    }
  }

  .top-heading {
    display: flex;
    flex-direction: row;
    align-items: center;

    h2 {
      margin: 0;
      padding-right: 20px;
    }
  }
}
</style>
